import React, { useEffect, useState } from "react";
import { TextField, CircularProgress } from "@mui/material";
import { Autocomplete } from "@mui/material";

import axiosHttp from "../../../../services/interceptor";

const PortCodeAutocomplete = ({
	defaultPortCodeMstId,
	onValueChange,
	setDefaultValue,
	readOnly,
}) => {
	const [options, setOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const [selectedOption, setSelectedOption] = useState(null);

	useEffect(() => {
		const fetchDefaultOption = async () => {
			if (defaultPortCodeMstId && defaultPortCodeMstId!=='0') {
				try {
					const response = await axiosHttp.get(
						`api/portcode/GetById?portCodeMstId=${defaultPortCodeMstId}`
					);
					setSelectedOption(response?.data);
					setDefaultValue(defaultPortCodeMstId);
				} catch (error) {
					console.error("Error fetching default port code:", error);
					setDefaultValue(null);
				}
			} else {
				setDefaultValue(null);
			}
		};
		fetchDefaultOption();
	}, [defaultPortCodeMstId]);

	const fetchOptions = async (query) => {
		setLoading(true);
		try {
			const response = await axiosHttp.get(
				`api/portcode/FetchPortCodes?key=${query}`
			);
			setOptions(response?.data?.data);
		} catch (error) {
			console.error("Error fetching port codes:", error);
		} finally {
			setLoading(false);
		}
	};


	return (
		<Autocomplete
			fullWidth
			getOptionLabel={(option) => {
				return `${option?.data?.portCode || option?.portCode} (${
					option?.data?.portName || option?.portName
				})`;
			}}
			options={options}
			loading={loading}
			value={selectedOption}
			onChange={(event, newValue) => {
				setSelectedOption(newValue);
				if (onValueChange) {
					onValueChange(newValue);
				}
			}}
			onInputChange={(event, newInputValue) => {
				if (newInputValue) {
					fetchOptions(newInputValue);
				}
			}}
			renderInput={(params) => (
				<TextField
					{...params}
					label="Port Code"
					variant="outlined"
					disabled={readOnly}
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<>
								{loading ? (
									<CircularProgress
										color="inherit"
										size={20}
									/>
								) : null}
								{params.InputProps.endAdornment}
							</>
						),
					}}
				/>
			)}
		/>
	);
};

export default PortCodeAutocomplete;
